import type { ApiClient } from '@klareospace/pharos-lib-front-utils';
import type {
  DriverAttributes,
  Invitation,
  PharosApiResponse,
  PhoneNumber,
  UserScope,
} from '@klareospace/pharos-lib-types';

export interface InviteUserParams {
  driverAttributes?: DriverAttributes | null;
  email: string;
  firstName: string;
  lastName: string;
  phone?: PhoneNumber | null;
  roles: string[];
  scopes: UserScope[];
}

export function createUserInvitationApi(client: ApiClient): {
  inviteUser: (params: InviteUserParams) => Promise<Invitation>;
  resendInvitationByEmail: (email: string) => Promise<void>;
} {
  return {
    inviteUser: async (params: InviteUserParams): Promise<Invitation> => {
      const response = await client.execute<PharosApiResponse<Invitation>>(() =>
        client.instance.post('/invitations', params),
      );
      if (!response.data) {
        throw new Error('Unexpected empty response from API');
      }
      return response.data;
    },

    resendInvitationByEmail: async (email: string): Promise<void> => {
      await client.execute<PharosApiResponse<void>>(() => client.instance.patch('/invitations/resend', { email }));
    },
  };
}
